import { render, staticRenderFns } from "./PartialContent.vue?vue&type=template&id=0d4c77f0&"
import script from "./PartialContent.vue?vue&type=script&lang=ts&"
export * from "./PartialContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports